import React, { FC } from 'react';
import { Link } from '@mui/material';
import { AgentRequestResponse } from '../../../structures/response/AgentRequestResponse';
import { ruble } from '../../../helpers/formatHelper';
import ViewItem from './ViewItem';

interface Props {
  data: AgentRequestResponse | null;
}

const AgentRequestView: FC<Props> = ({ data }) => {
  if (!data) {
    return null;
  }

  const {
    id,
    uploadedFiles,
    amountRequested,
    createdAt,
    inn,
    contactPhone,
    contactName,
    comment,
    statusLabel,
    hasPledge,
    amountToPay,
  } = data;

  return (
    <div>
      <ViewItem label="Заявка" value={id} />
      <ViewItem
        label="Запрошенная сумма"
        value={amountRequested ? ruble(+amountRequested) : ''}
      />
      <ViewItem
        label="Сумма вознаграждения"
        value={+amountToPay ? ruble(+amountToPay) : ''}
      />
      <ViewItem label="ИНН" value={inn} />
      <ViewItem label="Контактное лицо" value={contactName} />
      <ViewItem label="Телефон контактного лица" value={contactPhone} />
      <ViewItem label="Дата создания" value={createdAt} />
      <ViewItem label="Комментарий" value={comment} />
      <ViewItem label="Статус" value={statusLabel} />
      <ViewItem label="Есть залог" value={hasPledge ? 'Да' : ' Нет'} />
      <div>Загруженные файлы</div>
      {uploadedFiles.map((v) => (
        <div key={v.id}>
          <Link href={v.viewUrl} target="_blank">
            {v.name}
          </Link>
        </div>
      ))}
    </div>
  );
};

export default AgentRequestView;
